import { formatDateRu } from "../../../utils/appointmentLabels";
import s from "../clinic.module.css";
import { Button, Field, Input, useToast } from "../../ui";
import { medicalFormError } from "./athleteQualifications";

function medStatus(edit) {
  const granted = !!edit?.medical_clearance;
  const expiresAt = edit?.medical_clearance_expires_at;
  if (!granted) {
    return {
      tone: "muted",
      icon: "○",
      label: "Нет допуска",
      hint: "Отметьте, если справка есть, и укажите дату окончания",
    };
  }
  if (!expiresAt) {
    return {
      tone: "warn",
      icon: "●",
      label: "Допуск есть",
      hint: "Укажите дату окончания",
    };
  }
  const d = new Date(`${String(expiresAt).slice(0, 10)}T12:00:00`);
  if (Number.isNaN(d.getTime())) {
    return { tone: "muted", icon: "○", label: "Не задан", hint: null };
  }
  const days = Math.ceil((d.getTime() - Date.now()) / (1000 * 60 * 60 * 24));
  const dateLabel = formatDateRu(`${String(expiresAt).slice(0, 10)}T12:00:00`, {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
  if (days < 0) {
    return {
      tone: "danger",
      icon: "●",
      label: "Просрочена",
      hint: `Истекла ${dateLabel}`,
    };
  }
  if (days <= 14) {
    return {
      tone: "warn",
      icon: "●",
      label: "Истекает скоро",
      hint: `Действует до ${dateLabel} (${days} дн.)`,
    };
  }
  return {
    tone: "ok",
    icon: "●",
    label: "Действительна",
    hint: `До ${dateLabel}`,
  };
}

export default function ClientMedicalSection({
  edit,
  setEdit,
  onSave,
  editing,
  onToggleEdit,
  embedded = false,
  inFold = false,
}) {
  const toast = useToast();
  const status = medStatus(edit);
  const fileUrl = edit.medical_clearance_file_url?.trim();

  const content = (
    <>
      {!inFold ? (
        <div className={embedded ? s.clientProfileEmbeddedHead : s.clientProfileSectionHead}>
          {embedded ? (
            <h3 className={s.clientTabCardTitle}>Мед.допуск</h3>
          ) : (
            <h2 className={s.clientProfileSectionTitle}>Мед.допуск</h2>
          )}
          <button type="button" className={s.clientProfileSectionAction} onClick={onToggleEdit}>
            {editing ? "Готово" : "Обновить"}
          </button>
        </div>
      ) : null}

      <div className={s.clientMedStatusRow}>
        <span
          className={`${s.clientMedStatusIcon} ${s[`clientMedStatusIcon_${status.tone}`]}`}
          aria-hidden
        >
          {status.icon}
        </span>
        <div>
          <strong>{status.label}</strong>
          {status.hint ? <p className={s.clientTabMuted}>{status.hint}</p> : null}
        </div>
      </div>

      {edit.allergies?.trim() ? (
        <p className={s.clientMedAllergy}>
          <strong>Особые отметки:</strong> {edit.allergies}
        </p>
      ) : null}

      {fileUrl ? (
        <a
          href={fileUrl}
          target="_blank"
          rel="noreferrer"
          className={s.clientMedFileLink}
        >
          {fileUrl.match(/\.(jpg|jpeg|png|webp|gif)/i) ? (
            <img src={fileUrl} alt="Допуск" className={s.clientMedThumb} />
          ) : (
            <span>Открыть файл справки</span>
          )}
        </a>
      ) : null}

      {editing ? (
        <form
          className={s.clientTabFormStack}
          onSubmit={(e) => {
            e.preventDefault();
            const error = medicalFormError(edit);
            if (error) {
              toast.error(error);
              return;
            }
            onSave(e);
            onToggleEdit();
          }}
        >
          <label className={s.settingsToggleRow}>
            <input
              type="checkbox"
              checked={!!edit.medical_clearance}
              onChange={(e) =>
                setEdit({ ...edit, medical_clearance: e.target.checked })
              }
            />
            <span>Допуск есть</span>
          </label>
          <Field label="Дата окончания">
            <Input
              type="date"
              required={!!edit.medical_clearance}
              value={edit.medical_clearance_expires_at || ""}
              onChange={(e) =>
                setEdit({ ...edit, medical_clearance_expires_at: e.target.value })
              }
            />
          </Field>
          <Field label="Ссылка на скан">
            <Input
              value={edit.medical_clearance_file_url || ""}
              onChange={(e) =>
                setEdit({ ...edit, medical_clearance_file_url: e.target.value })
              }
              placeholder="https://…"
            />
          </Field>
            <Field label="Особые отметки">
            <Input
              value={edit.allergies || ""}
              onChange={(e) => setEdit({ ...edit, allergies: e.target.value })}
            />
          </Field>
          <Button type="submit" size="sm">
            Сохранить
          </Button>
        </form>
      ) : null}
    </>
  );

  if (embedded) {
    return <div className={s.clientProfileEmbeddedBlock}>{content}</div>;
  }

  return (
    <section id="client-medicine" className={s.clientProfileSection}>
      {content}
    </section>
  );
}
